export default {
  confirm: '確認',
  cancel: 'キャンセル',
  save: '保存',
  noSave: '保存しない',
  delete: '削除',
  edit: '編集',
  add: '追加',
  search: '検索',
  reset: 'リセット',
  back: '戻る',
  submit: '送信',
  loading: '読み込み中...',
  noData: 'データなし',
  noMoreData: 'データがありません',
  success: '操作が成功しました',
  failed: '操作に失敗しました',
  required: '必須項目です',
  development: '開発中',
  underConstruction: '機能構築中',
  all: 'すべて',
  operation: '操作',
  pleaseInputLanguage: '言語を入力してください',
  pleaseSelect: '選択してください',
  upload: 'アップロード',
  uploadVideo: '動画をアップロード',
  uploadImage: '画像をアップロード',
  previousStep: '前へ',
  nextStep: '次へ',
  sort: '並び替え',
  multilingual: '多言語',
  languageVersion: '言語バージョン',
  pleaseInput: '入力してください',
  select: '選択',
  total: '合計',
  item: '件',
  updatedAt: '更新日時',
  current: '現在',
  switch: '切り替え',
  copy: 'コピー',
  pleaseEnter: '入力してください',
  comingSoon: '機能開発中',
  home: 'ホーム',
  action: '操作',
  warning: '警告',
  logout: 'ログアウト',
  logoutConfirm: 'ログアウト確認',
  logoutConfirmContent: 'ログアウトしてもよろしいですか？',
  user: 'ユーザー',
  adminTitle: '管理画面',
  selectField: 'フィールドを選択',
  none: 'なし',
  copySuccess: 'コピーしました',
  copyFailed: 'コピーに失敗しました',
  tip: 'ヒント',
};
